import { closePopup, openPopup } from '@/popups';

export function popupLectorSendReview() {
  const $button = $('.popup-lector-send-review');
  if ($button && $button.length === 0) return;

  $button.on('click', (e) => {
    e.preventDefault();
    closePopup($('#popup-lector-review'));
    openPopup($('#popup-lector-review-thankyou'));
  });
}
